import { StandardProduct, ValidatedProductRow } from "@/api/api";

export interface StandardProductRecord extends StandardProduct {
  // Ticked rows are written on save
  selected: boolean;
  // Name shown in the row: saved name, suggestion or one picked this session
  name: string;
  initialName: string;
  // undefined = image untouched this session, null = "Ingen bild" chosen
  pickedImageId: number | null | undefined;
}

export function createRecord(product: StandardProduct): StandardProductRecord {
  let name = (product.saved ? product.savedName : undefined) ?? product.suggestedName ?? "";
  return {
    ...product,
    selected: product.saved ?? false,
    name: name,
    initialName: name,
    pickedImageId: undefined,
  };
}

// Name or image changed this session
export function isEdited(record: StandardProductRecord): boolean {
  return record.name !== record.initialName || record.pickedImageId !== undefined;
}

export function hasChanges(record: StandardProductRecord): boolean {
  return isEdited(record) || record.selected !== (record.saved ?? false);
}

export function toSaveRow(record: StandardProductRecord): ValidatedProductRow {
  if (record.pickedImageId !== undefined) {
    return {
      plu: record.plu,
      name: record.name,
      imageid: record.pickedImageId ?? undefined,
      keepimage: false,
    };
  }
  if (record.saved) {
    return { plu: record.plu, name: record.name, keepimage: true };
  }
  return {
    plu: record.plu,
    name: record.name,
    imageid: record.suggestedImageId ?? undefined,
    keepimage: false,
  };
}
